import { GenericSummaryCard, GenericSummaryCardProps } from "components/Common/GenericSummaryCard";
import { TAG_VIEW } from "constants/Routes";
import { TagType } from "tags/types";

const TagItem = ({ tag }: { tag: TagType }) => {
  const tagObj = {
    id: tag.id,
    title: tag.name,
    icon: {
      color: tag.color,
      value: "tags",
      ownership: tag.ownership,
    },
    animalCount: tag.numAliveAnimals,
    onClickUrl: `${TAG_VIEW}/${tag.id}`,
  } as GenericSummaryCardProps;
  return <GenericSummaryCard item={tagObj} />;
};

export default TagItem;
